import { Button, ButtonProps } from '@material-ui/core';
import React from 'react';
import useToggle from '../Hooks/useToggle';
import ConfirmOperation from './ConfirmOperation';
interface DeleteButtonWithConfirmationProps extends ButtonProps {
    dataItem?: any;
    message: string;
    isLoading: boolean;
    // isSuccess:boolean;
    // isError: boolean;
    onDeleteConfirmed: any;
    children?: JSX.Element;
    gridData?: any;
    withoutHeaderStyle?: boolean;
}

const DeleteButtonWithConfirmation: React.FC<DeleteButtonWithConfirmationProps> = ({
    dataItem,
    message,
    isLoading,
    onDeleteConfirmed,
    children,
    gridData,
    ...props
}) => {
    const [open, toggleOpen] = useToggle(false);

    return (
        <>
            <Button
                variant="contained"
                className={props.className}
                onClick={(e: any) => {
                    if (gridData?.some((x: any) => x.inEdit == true)) e.preventDefault();
                    else toggleOpen();
                }}
                color={props.color}
                style={props.style}
                size={props.size}
                {...props}
            >
                {children}
            </Button>
            {open && (
                <ConfirmOperation
                    message={message}
                    isLoading={isLoading}
                    onClose={toggleOpen}
                    operation={() => {
                        onDeleteConfirmed(dataItem);
                    }}
                    withoutHeaderStyle={props.withoutHeaderStyle}
                />
            )}
        </>
    );
};

export default DeleteButtonWithConfirmation;
